import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EuiTextareaComponent } from './eui-textarea.component';
import { AutoResizeDirective } from './auto-resize.directive';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiTextareaComponent,
        AutoResizeDirective
    ],
    exports: [
        EuiTextareaComponent,
        AutoResizeDirective
    ],
})
export class EuiTextAreaModule { }
